import { useCallback, useState } from 'react';

const VOICE_KEY = 'stockaris_operator_voice';

const _speak = (text) => {
  if (typeof window === 'undefined' || !window.speechSynthesis) return;
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 1.05;
    u.pitch = 1.0;
    u.volume = 1.0;
    window.speechSynthesis.speak(u);
  } catch (_) {
    /* speech synthesis not available */
  }
};

/**
 * Voice-prompts hook for the Operator Console flows.
 *
 * - Persists `voiceOn` to localStorage under `stockaris_operator_voice`.
 * - `speak(text)` is a no-op when voice is off.
 * - `toggleVoice()` flips state and announces "Voice prompts on" on the way ON.
 */
export function useVoice() {
  const [voiceOn, setVoiceOn] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(VOICE_KEY) === 'true';
  });

  const speak = useCallback(
    (text) => {
      if (!voiceOn) return;
      _speak(text);
    },
    [voiceOn],
  );

  const toggleVoice = useCallback(() => {
    setVoiceOn((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(VOICE_KEY, String(next));
      } catch (_) {
        /* ignore */
      }
      if (next) {
        _speak('Voice prompts on');
      } else if (typeof window !== 'undefined' && window.speechSynthesis) {
        window.speechSynthesis.cancel();
      }
      return next;
    });
  }, []);

  return { voiceOn, toggleVoice, speak };
}

export const formatLocationForSpeech = (code) => (code || '').split('-').join(' ');
